import type { ReactNode } from 'react';

interface PageHeadProps {
  title: string;
  desc?: string;
  eyebrow?: string;
  actions?: ReactNode;
}

export function PageHead({ title, desc, eyebrow, actions }: PageHeadProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        gap: 20,
        marginBottom: 22,
        flexWrap: 'wrap'
      }}
    >
      <div>
        {eyebrow && <div className="eyebrow" style={{ marginBottom: 8 }}>{eyebrow}</div>}
        <h1 style={{ fontSize: 24, marginBottom: desc ? 6 : 0, letterSpacing: '-0.02em' }}>
          {title}
        </h1>
        {desc && (
          <p style={{ fontSize: 13.5, color: 'var(--text-2)', maxWidth: 640 }}>{desc}</p>
        )}
      </div>
      {actions && <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>{actions}</div>}
    </div>
  );
}
